
import { useState } from 'react';
import Logo from '../../../components/base/Logo';

const YandexSeoPage = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    website: '',
    message: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState('');

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitStatus('');

    try {
      const formDataToSend = new URLSearchParams();
      Object.entries(formData).forEach(([key, value]) => {
        formDataToSend.append(key, value);
      });

      const response = await fetch('https://readdy.ai/api/form/yandex-seo-request', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: formDataToSend
      });

      if (response.ok) {
        setSubmitStatus('success');
        setFormData({
          name: '',
          email: '',
          phone: '',
          website: '',
          message: ''
        });
      } else {
        setSubmitStatus('error');
      }
    } catch (error) {
      setSubmitStatus('error');
    } finally {
      setIsSubmitting(false);
    }
  };

  const features = [
    {
      title: 'Накрутка поведенческих факторов',
      description: 'Собственный сервис для улучшения поведенческих метрик в Яндексе',
      icon: 'ri-user-heart-line',
      highlight: true
    },
    {
      title: 'Гарантия ТОП-1',
      description: 'Гарантируем попадание в первую позицию по целевым запросам',
      icon: 'ri-trophy-line',
      highlight: true
    },
    {
      title: 'Работа с Яндекс.Вебмастер',
      description: 'Полная настройка и оптимизация через инструменты Яндекса',
      icon: 'ri-tools-line',
      highlight: false
    },
    {
      title: 'Региональное продвижение',
      description: 'Специализация на продвижении в российских регионах',
      icon: 'ri-map-pin-line',
      highlight: false
    },
    {
      title: 'Анализ Яндекс.Метрики',
      description: 'Глубокая аналитика поведения пользователей',
      icon: 'ri-line-chart-line',
      highlight: false
    },
    {
      title: 'Турбо-страницы',
      description: 'Создание и оптимизация турбо-страниц для мобильного трафика',
      icon: 'ri-rocket-line',
      highlight: false
    }
  ];

  const advantages = [
    {
      title: 'Собственный сервис накрутки',
      description: 'Уникальная технология улучшения поведенческих факторов, разработанная нашей командой',
      icon: 'ri-shield-star-line'
    },
    {
      title: 'Знание алгоритмов Яндекса',
      description: 'Глубокое понимание особенностей ранжирования в российской поисковой системе',
      icon: 'ri-brain-line'
    },
    {
      title: 'Быстрые результаты',
      description: 'Первые улучшения позиций заметны уже через 2-4 недели работы',
      icon: 'ri-speed-line'
    },
    {
      title: 'Безопасные методы',
      description: 'Используем только белые методы продвижения, исключающие санкции',
      icon: 'ri-shield-check-line'
    }
  ];

  const results = [
    {
      metric: '+340%',
      description: 'Рост органического трафика',
      icon: 'ri-arrow-up-line'
    },
    {
      metric: '85%',
      description: 'Запросов в ТОП-10',
      icon: 'ri-trophy-line'
    },
    {
      metric: '2-4 недели',
      description: 'До первых результатов',
      icon: 'ri-time-line'
    },
    {
      metric: '100%',
      description: 'Гарантия результата',
      icon: 'ri-shield-check-line'
    }
  ];

  return (
    <div className="min-h-screen bg-white">
      {/* Navigation */}
      <nav className="fixed top-0 left-0 right-0 bg-white/95 backdrop-blur-sm border-b border-gray-200 z-50">
        <div className="container mx-auto px-6">
          <div className="flex items-center justify-between h-16">
            <Logo />
            
            <div className="hidden md:flex items-center space-x-8">
              <a href="/#services" className="text-gray-700 hover:text-blue-600 transition-colors cursor-pointer">Услуги</a>
              <a href="/#tariffs" className="text-gray-700 hover:text-blue-600 transition-colors cursor-pointer">Тарифы</a>
              <a href="/#cases" className="text-gray-700 hover:text-blue-600 transition-colors cursor-pointer">Кейсы</a>
              <a href="/blog" className="text-gray-700 hover:text-blue-600 transition-colors cursor-pointer">Блог</a>
              <button 
                onClick={() => document.getElementById('order-form')?.scrollIntoView({ behavior: 'smooth' })}
                className="bg-red-600 hover:bg-red-700 text-white px-6 py-2 rounded-lg font-semibold transition-colors whitespace-nowrap cursor-pointer"
              >
                Заказать продвижение
              </button>
            </div>
            
            <button className="md:hidden text-gray-700 cursor-pointer">
              <i className="ri-menu-line text-2xl"></i>
            </button>
          </div>
        </div>
      </nav>

      {/* Hero Section */}
      <section 
        className="relative min-h-screen flex items-center justify-center bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage: `linear-gradient(rgba(255, 0, 0, 0.1), rgba(0, 0, 0, 0.7)), url('https://readdy.ai/api/search-image?query=Yandex%20search%20engine%20optimization%20workspace%20with%20Russian%20language%20interface%2C%20Yandex%20Webmaster%20tools%20on%20screen%2C%20behavioral%20factors%20analytics%2C%20red%20and%20white%20Yandex%20branding%20elements%2C%20professional%20SEO%20environment&width=1920&height=1080&seq=yandex-seo-hero&orientation=landscape')`
        }}
      >
        <div className="container mx-auto px-6 text-center text-white">
          <h1 className="text-5xl md:text-7xl font-bold mb-6 leading-tight">
            Продвижение в<br />
            <span className="text-red-400">Яндексе</span>
          </h1>
          <p className="text-xl md:text-2xl mb-8 max-w-3xl mx-auto leading-relaxed">
            Специализированное SEO продвижение в Яндексе с накруткой поведенческих факторов и гарантией ТОП-1
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <button 
              onClick={() => document.getElementById('order-form')?.scrollIntoView({ behavior: 'smooth' })}
              className="bg-red-600 hover:bg-red-700 text-white px-8 py-4 rounded-lg text-lg font-semibold transition-colors whitespace-nowrap cursor-pointer"
            >
              Заказать продвижение
            </button>
            <button 
              onClick={() => document.getElementById('features')?.scrollIntoView({ behavior: 'smooth' })}
              className="border-2 border-white text-white hover:bg-white hover:text-gray-900 px-8 py-4 rounded-lg text-lg font-semibold transition-colors whitespace-nowrap cursor-pointer"
            >
              Наши возможности
            </button>
          </div>
        </div>
      </section>

      {/* Results Section */}
      <section className="py-20 bg-red-50">
        <div className="container mx-auto px-6">
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">Результаты наших клиентов</h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              Конкретные цифры эффективности продвижения в Яндексе
            </p>
          </div>
          
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
            {results.map((result, index) => (
              <div key={index} className="bg-white rounded-xl p-8 shadow-lg hover:shadow-xl transition-shadow text-center">
                <div className="w-16 h-16 bg-red-100 rounded-lg flex items-center justify-center mb-6 mx-auto">
                  <i className={`${result.icon} text-2xl text-red-600`}></i>
                </div>
                <div className="text-3xl font-bold text-red-600 mb-2">{result.metric}</div>
                <p className="text-gray-600">{result.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Features Section */}
      <section id="features" className="py-20 bg-white">
        <div className="container mx-auto px-6">
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">Что включает продвижение</h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              Комплексный подход к продвижению в Яндексе
            </p>
          </div>
          
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            {features.map((feature, index) => (
              <div key={index} className={`relative bg-white rounded-xl p-8 shadow-lg hover:shadow-xl transition-shadow ${feature.highlight ? 'ring-2 ring-red-500' : ''}`}>
                {feature.highlight && (
                  <div className="absolute -top-4 left-1/2 transform -translate-x-1/2">
                    <span className="bg-red-500 text-white px-4 py-2 rounded-full text-sm font-semibold whitespace-nowrap">
                      Эксклюзивно
                    </span>
                  </div>
                )}
                <div className="w-16 h-16 bg-red-100 rounded-lg flex items-center justify-center mb-6">
                  <i className={`${feature.icon} text-2xl text-red-600`}></i>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-4">{feature.title}</h3>
                <p className="text-gray-600">{feature.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Advantages Section */}
      <section className="py-20 bg-gray-50">
        <div className="container mx-auto px-6">
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">Наши преимущества</h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              Почему стоит выбрать нас для продвижения в Яндексе
            </p>
          </div>
          
          <div className="grid md:grid-cols-2 gap-12">
            {advantages.map((advantage, index) => (
              <div key={index} className="flex items-start space-x-6">
                <div className="w-16 h-16 bg-red-100 rounded-lg flex items-center justify-center flex-shrink-0">
                  <i className={`${advantage.icon} text-2xl text-red-600`}></i>
                </div>
                <div>
                  <h3 className="text-xl font-bold text-gray-900 mb-3">{advantage.title}</h3>
                  <p className="text-gray-600">{advantage.description}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Behavioral Factors Section */}
      <section className="py-20 bg-white">
        <div className="container mx-auto px-6">
          <div className="grid md:grid-cols-2 gap-12 items-center">
            <div>
              <h2 className="text-4xl font-bold text-gray-900 mb-6">
                Собственный сервис накрутки поведенческих факторов
              </h2>
              <p className="text-xl text-gray-600 mb-8">
                Уникальная технология, которая безопасно улучшает поведенческие метрики вашего сайта в Яндексе
              </p>
              
              <div className="space-y-4">
                <div className="flex items-center space-x-3">
                  <div className="w-6 h-6 bg-red-100 rounded-full flex items-center justify-center">
                    <i className="ri-check-line text-red-600 text-sm"></i>
                  </div>
                  <span className="text-gray-700">Увеличение времени на сайте</span>
                </div>
                <div className="flex items-center space-x-3">
                  <div className="w-6 h-6 bg-red-100 rounded-full flex items-center justify-center">
                    <i className="ri-check-line text-red-600 text-sm"></i>
                  </div>
                  <span className="text-gray-700">Снижение показателя отказов</span>
                </div>
                <div className="flex items-center space-x-3">
                  <div className="w-6 h-6 bg-red-100 rounded-full flex items-center justify-center">
                    <i className="ri-check-line text-red-600 text-sm"></i>
                  </div>
                  <span className="text-gray-700">Увеличение глубины просмотра</span>
                </div>
                <div className="flex items-center space-x-3">
                  <div className="w-6 h-6 bg-red-100 rounded-full flex items-center justify-center">
                    <i className="ri-check-line text-red-600 text-sm"></i>
                  </div>
                  <span className="text-gray-700">Рост повторных посещений</span>
                </div>
              </div>
            </div>
            <div>
              <img 
                src="https://readdy.ai/api/search-image?query=Behavioral%20factors%20analytics%20dashboard%20showing%20user%20engagement%20metrics%2C%20time%20on%20site%20statistics%2C%20bounce%20rate%20improvements%2C%20Yandex%20Metrica%20interface%20with%20positive%20growth%20charts%20and%20user%20behavior%20data&width=600&height=400&seq=behavioral-factors&orientation=landscape"
                alt="Поведенческие факторы"
                className="w-full rounded-xl shadow-lg object-cover object-top"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Order Form Section */}
      <section id="order-form" className="py-20 bg-red-50">
        <div className="container mx-auto px-6">
          <div className="max-w-4xl mx-auto">
            <div className="text-center mb-12">
              <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">Заказать продвижение в Яндексе</h2>
              <p className="text-xl text-gray-600">
                Получите ТОП-1 позиции с гарантией результата
              </p>
            </div>
            
            <form 
              id="yandex-seo-order"
              data-readdy-form
              onSubmit={handleSubmit} 
              className="bg-white rounded-xl p-8 shadow-lg"
            >
              <div className="grid md:grid-cols-2 gap-6 mb-6">
                <div>
                  <label htmlFor="name" className="block text-sm font-semibold text-gray-700 mb-2">
                    Ваше имя *
                  </label>
                  <input
                    type="text"
                    id="name"
                    name="name"
                    value={formData.name}
                    onChange={handleInputChange}
                    required
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-red-500 focus:border-transparent text-sm"
                    placeholder="Введите ваше имя"
                  />
                </div>
                
                <div>
                  <label htmlFor="email" className="block text-sm font-semibold text-gray-700 mb-2">
                    Email *
                  </label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    value={formData.email}
                    onChange={handleInputChange}
                    required
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-red-500 focus:border-transparent text-sm"
                    placeholder="your@email.com"
                  />
                </div>
              </div>
              
              <div className="grid md:grid-cols-2 gap-6 mb-6">
                <div>
                  <label htmlFor="phone" className="block text-sm font-semibold text-gray-700 mb-2">
                    Телефон *
                  </label>
                  <input
                    type="tel"
                    id="phone"
                    name="phone"
                    value={formData.phone}
                    onChange={handleInputChange}
                    required
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-red-500 focus:border-transparent text-sm"
                    placeholder="+7 (999) 123-45-67"
                  />
                </div>
                
                <div>
                  <label htmlFor="website" className="block text-sm font-semibold text-gray-700 mb-2">
                    Сайт для продвижения *
                  </label>
                  <input
                    type="url"
                    id="website"
                    name="website"
                    value={formData.website}
                    onChange={handleInputChange}
                    required
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-red-500 focus:border-transparent text-sm"
                    placeholder="https://yoursite.com"
                  />
                </div>
              </div>
              
              <div className="mb-6">
                <label htmlFor="message" className="block text-sm font-semibold text-gray-700 mb-2">
                  Целевые запросы и пожелания
                </label>
                <textarea
                  id="message"
                  name="message"
                  value={formData.message}
                  onChange={handleInputChange}
                  maxLength={500}
                  rows={4}
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-red-500 focus:border-transparent text-sm resize-vertical"
                  placeholder="Укажите ключевые запросы, по которым хотите продвигаться, регион, особенности бизнеса..."
                ></textarea>
                <div className="text-right text-xs text-gray-500 mt-1">
                  {formData.message.length}/500
                </div>
              </div>
              
              <button
                type="submit"
                disabled={isSubmitting}
                className="w-full bg-red-600 hover:bg-red-700 disabled:bg-red-400 text-white py-4 rounded-lg text-lg font-semibold transition-colors whitespace-nowrap cursor-pointer"
              >
                {isSubmitting ? 'Отправка...' : 'Заказать продвижение в Яндексе'}
              </button>
              
              {submitStatus === 'success' && (
                <div className="mt-4 p-4 bg-green-100 border border-green-400 text-green-700 rounded-lg">
                  Спасибо! Ваша заявка принята. Мы свяжемся с вами в течение часа для обсуждения стратегии продвижения.
                </div>
              )}
              
              {submitStatus === 'error' && (
                <div className="mt-4 p-4 bg-red-100 border border-red-400 text-red-700 rounded-lg">
                  Произошла ошибка при отправке. Пожалуйста, попробуйте еще раз.
                </div>
              )}
            </form>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-gray-900 text-white py-12">
        <div className="container mx-auto px-6">
          <div className="grid md:grid-cols-4 gap-8">
            <div>
              <Logo className="text-white mb-4" />
              <p className="text-gray-400 mb-4">
                Профессиональное SEO продвижение для вашего бизнеса
              </p>
              <div className="flex space-x-4">
                <a href="#" className="text-gray-400 hover:text-white transition-colors cursor-pointer">
                  <i className="ri-facebook-fill text-xl"></i>
                </a>
                <a href="#" className="text-gray-400 hover:text-white transition-colors cursor-pointer">
                  <i className="ri-instagram-fill text-xl"></i>
                </a>
                <a href="#" className="text-gray-400 hover:text-white transition-colors cursor-pointer">
                  <i className="ri-linkedin-fill text-xl"></i>
                </a>
              </div>
            </div>
            
            <div>
              <h4 className="text-lg font-semibold mb-4">Услуги</h4>
              <ul className="space-y-2">
                <li><a href="/services/seo-audit" className="text-gray-400 hover:text-white transition-colors cursor-pointer">SEO Аудит</a></li>
                <li><a href="/services/yandex-seo" className="text-gray-400 hover:text-white transition-colors cursor-pointer">Продвижение в Яндексе</a></li>
                <li><a href="/services/google-seo" className="text-gray-400 hover:text-white transition-colors cursor-pointer">Продвижение в Google</a></li>
                <li><a href="/services/yandex-maps" className="text-gray-400 hover:text-white transition-colors cursor-pointer">Яндекс Карты</a></li>
              </ul>
            </div>
            
            <div>
              <h4 className="text-lg font-semibold mb-4">Компания</h4>
              <ul className="space-y-2">
                <li><a href="/#cases" className="text-gray-400 hover:text-white transition-colors cursor-pointer">Кейсы</a></li>
                <li><a href="/#tariffs" className="text-gray-400 hover:text-white transition-colors cursor-pointer">Тарифы</a></li>
                <li><a href="/blog" className="text-gray-400 hover:text-white transition-colors cursor-pointer">Блог</a></li>
                <li><a href="/#consultation-form" className="text-gray-400 hover:text-white transition-colors cursor-pointer">Контакты</a></li>
              </ul>
            </div>
            
            <div>
              <h4 className="text-lg font-semibold mb-4">Контакты</h4>
              <ul className="space-y-2 text-gray-400">
                <li className="flex items-center">
                  <i className="ri-phone-line mr-2"></i>
                  +7 (950) 360-35-20
                </li>
                <li className="flex items-center">
                  <i className="ri-mail-line mr-2"></i>
                  info@seo-vektor.ru
                </li>
                <li className="flex items-center">
                  <i className="ri-time-line mr-2"></i>
                  Пн-Пт: 9:00-18:00
                </li>
              </ul>
            </div>
          </div>
          
          <div className="border-t border-gray-800 mt-8 pt-8 text-center text-gray-400">
            <p>&copy; 2024 SEO Продвижение. Все права защищены. | 
              <a href="https://readdy.ai/?origin=logo" className="hover:text-white transition-colors cursor-pointer ml-1">
                Website Builder
              </a>
            </p>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default YandexSeoPage;
